import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import './ServiceHeader.pcss';
import Breadcrumbs from '@mos-front-components/public/es/components/Breadcrumbs';
import AboutService from '@mos-front-components/public/es/components/AboutService';
import { useAuthorizationStatus } from '@mos-utils/acs-react';
import Favorite from '../Favorite/Favorite';
import { basename } from '../../AppHistory';

import {
  loadServiceFavouriteStatus,
  changeServiceFavoriteStatus
} from '../../store/favorite/actions';

import {
  ServiceHeaderPropTypes,
  ServiceHeaderStructuredSelector
} from './ServiceHeaderSelector';

const ServiceHeader = ({
  breadcrumbs,
  aboutServiceData: { titleToggle, titleWindow, titleCloseBtn, content },
  inFavorite,
  handleChangeServiceFavoriteStatus
}) => {
  const { value } = useAuthorizationStatus();

  const breadcrumbsData = {
    breadcrumbs,
    className: ''
  };

  return (
    <div className="ServiceHeader">
      <Breadcrumbs {...breadcrumbsData} />
      {value === 'authorized' &&
      window.location.href !== `${window.location.origin}${basename}` ? (
        <Favorite
          inFavorite={inFavorite}
          onChange={handleChangeServiceFavoriteStatus}
        />
      ) : null}
      <AboutService
        titleToggle={titleToggle}
        titleWindow={titleWindow}
        titleCloseBtn={titleCloseBtn}
      >
        {content}
      </AboutService>
    </div>
  );
};

ServiceHeader.propTypes = {
  ...ServiceHeaderPropTypes,
  aboutServiceData: PropTypes.shape({
    titleToggle: PropTypes.node,
    titleWindow: PropTypes.node,
    titleCloseBtn: PropTypes.string,
    content: PropTypes.node.isRequired
  }),
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string,
      name: PropTypes.node.isRequired,
      active: PropTypes.bool,
      forMobile: PropTypes.bool
    })
  ).isRequired,
  handleLoadServiceFavouriteStatus: PropTypes.func.isRequired,
  handleChangeServiceFavoriteStatus: PropTypes.func.isRequired
};

ServiceHeader.defaultProps = {
  aboutServiceData: {},
  breadcrumbsData: {}
};

const mapDispatchToProps = dispatch => ({
  handleLoadServiceFavouriteStatus: () =>
    dispatch(loadServiceFavouriteStatus()),
  handleChangeServiceFavoriteStatus: () =>
    dispatch(changeServiceFavoriteStatus())
});

export default connect(
  ServiceHeaderStructuredSelector,
  mapDispatchToProps
)(ServiceHeader);
